import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { Autoplay, FreeMode } from 'swiper/modules';
import '../../styles/MetaSistema.css';
import logosData from '../../data/strategicAlliances.json'; // Importando el JSON

const StrategicAlliances = () => {
  return (
    <section className="strategic-alliances-section">
      <div className='container'>
        {/* Título */}
        <div className="title-container" data-aos="fade-up">
          <h2 className="title">Alianzas estratégicas</h2>
          <div className="title-underline"></div>
        </div>

        {/* Contenido principal */}
        <div className="section-description" data-aos="fade-up">
          <p>
            <span className="description-highlight">Ampliamos nuestra red de socios estratégicos</span> para fortalecer nuestra presencia digital y
            ofrecer resultados de mayor valor a nuestros clientes.
          </p>
        </div>

        {/* Carrusel de logos */}
        <div className="logo-carousel-container d-flex justify-content-center text-center align-items-center" data-aos="fade-up" data-aos-offset="0">
          <Swiper
            modules={[Autoplay, FreeMode]}
            spaceBetween={10}
            freeMode={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false
            }}
            speed={3000}
            loop={true}
            breakpoints={{
              320: { slidesPerView: 1 },  // Móviles: 2 logos
              480: { slidesPerView: 2 },  // Pantallas pequeñas: 3 logos
              768: { slidesPerView: 3 },  // Tablets: 4 logos
              1024: { slidesPerView: 4 }, // Escritorio: 5 logos
              1280: { slidesPerView: 6 }  // Pantallas grandes: 6 logos
            }}
          >
            {logosData.logos.map((logo) => (
              <SwiperSlide key={logo.id} className="logo-slide">
                <img src={logo.src} alt={logo.alt} data-aos="flip-left" data-aos-offset="0" className='img-fluid' />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default StrategicAlliances;